import { useEffect } from "react";
import { getThemeContext, getThemeToggleContext } from "../../providers/ThemeProvider.jsx";
import { SunIcon, MoonIcon } from "@heroicons/react/24/outline";
import { motion, AnimatePresence } from "framer-motion";

const DarkModeToggle = () => {
    const theme = getThemeContext();
    const themeToggle = getThemeToggleContext();

    /*useEffect(() => {
        console.log("theme", theme);
    }, [theme]);*/

    const isDark = theme === "dark";

    return (
        <label
            className="relative inline-flex items-center cursor-pointer"
            onClick={(e) => e.stopPropagation()} // Evita que se cierre el dropdown
        >
            <input
                type="checkbox"
                checked={isDark}
                className="sr-only peer"
                onChange={themeToggle}
            />

            <motion.div
                className="relative w-14 h-8 bg-gray-200 dark:bg-gray-700 peer-checked:bg-gray-600 rounded-full flex items-center justify-between px-1"
                layout
                transition={{ type: "spring", stiffness: 300, damping: 20 }}
            >
                {/* Ícono de sol (izquierda) */}
                <motion.div
                    initial={{ rotate: 0 }}
                    animate={{ rotate: isDark ? -25 : 0, opacity: isDark ? 0.5 : 1 }}
                    transition={{ duration: 0.3 }}
                >
                    <SunIcon className="h-4 w-4 text-yellow-400" />
                </motion.div>

                {/* Ícono de luna (derecha) */}
                <motion.div
                    initial={{ rotate: 0 }}
                    animate={{ rotate: isDark ? 0 : 25, opacity: isDark ? 1 : 0.5 }}
                    transition={{ duration: 0.3 }}
                >
                    <MoonIcon className="h-4 w-4 text-gray-600" />
                </motion.div>

                {/* Handle con ícono dinámico */}
                <motion.div
                    className="absolute top-1 left-1 w-6 h-6 bg-white rounded-full shadow-md flex items-center justify-center"
                    layout
                    transition={{ type: "spring", stiffness: 300, damping: 20 }}
                    style={{ x: isDark ? 24 : 0 }}
                >
                    <AnimatePresence mode="wait" initial={false}>
                        {isDark ? (
                            <motion.div
                                key="moon-icon"
                                initial={{ scale: 0.5, rotate: 180, opacity: 0 }}
                                animate={{ scale: 1, rotate: 0, opacity: 1 }}
                                exit={{ scale: 0.5, rotate: -180, opacity: 0 }}
                                transition={{ duration: 0.3 }}
                            >
                                <MoonIcon className="h-4 w-4 text-blue-600" />
                            </motion.div>
                        ) : (
                            <motion.div
                                key="sun-icon"
                                initial={{ scale: 0.5, rotate: -180, opacity: 0 }}
                                animate={{ scale: 1, rotate: 0, opacity: 1 }}
                                exit={{ scale: 0.5, rotate: 180, opacity: 0 }}
                                transition={{ duration: 0.3 }}
                            >
                                <SunIcon className="h-4 w-4 text-yellow-500" />
                            </motion.div>
                        )}
                    </AnimatePresence>
                </motion.div>
            </motion.div>
        </label>
    );
};

export default DarkModeToggle;
